import { useEffect, useState } from 'react'

import { Slice } from '~/bootcamp/Activities/types/activities.types'
import { randomIntFromInterval } from '~/bootcamp/Activities/utils/activities.utils'
import { Breakpoint, useBreakpoint } from '~/utils'

import SliceCompo from './Slice'

import styles from './CircleWithSlice.module.css'

interface Props {
  isSelected?: boolean
  isWrong?: boolean
  numOfNumerator: number
  numOfDenominator: number
  toggleColorAction?: (data: Slice[]) => void | undefined
  className?: string
  isRandomFill?: boolean
  onClick?: () => void
}

export function CircleWithSlice({
  isSelected = false,
  isWrong,
  numOfNumerator = 0,
  numOfDenominator = 2,
  toggleColorAction = undefined,
  className = '',
  isRandomFill = true,
  ...rest
}: Props): React.ReactElement {
  const br = useBreakpoint()
  const RADIUS = br < Breakpoint.SM ? 45 : 70
  const PADDING = 5
  const [slices, setSlices] = useState<Slice[]>([])

  useEffect(() => {
    const randomNumber: number[] = []
    const history: number[] = []

    if (isRandomFill) {
      new Array(numOfNumerator).fill(null).forEach(() => {
        const randomIndex = randomIntFromInterval(0, numOfDenominator - 1, history)
        history[history.length] = randomIndex
        randomNumber[randomNumber.length] = randomIndex
      })
    } else {
      const colorStartPosition = randomIntFromInterval(0, numOfDenominator - numOfNumerator)
      new Array(numOfNumerator).fill(null).forEach((item, index) => {
        randomNumber[randomNumber.length] = index + colorStartPosition
      })
    }

    const sliceArr: Slice[] = new Array(numOfDenominator).fill(null).map((x, i) => ({ id: i, isColored: false }))
    sliceArr.forEach((item, i: number) => {
      const point1 = {
        x: Math.cos(((Math.PI * 2) / numOfDenominator) * i) * RADIUS + RADIUS + PADDING,
        y: Math.sin(((Math.PI * 2) / numOfDenominator) * i) * RADIUS + RADIUS + PADDING,
      }

      const point2 = {
        x: Math.cos(((Math.PI * 2) / numOfDenominator) * (i + 1)) * RADIUS + RADIUS + PADDING,
        y: Math.sin(((Math.PI * 2) / numOfDenominator) * (i + 1)) * RADIUS + RADIUS + PADDING,
      }

      sliceArr[i].isColored = !!randomNumber.includes(i)
      sliceArr[i].point1 = point1
      sliceArr[i].point2 = point2
    })
    setSlices(sliceArr)
  }, [numOfDenominator, numOfNumerator, isRandomFill, RADIUS])

  useEffect(() => {
    if (toggleColorAction) {
      toggleColorAction(slices)
    }
  }, [slices, toggleColorAction])

  const handleToggleColors = (id: number): void => {
    if (toggleColorAction) {
      setSlices((prevState) => {
        const newState = [...prevState]
        const index = newState.findIndex((item) => item.id === id)
        newState[index] = {
          ...newState[index],
          isColored: !newState[index].isColored,
        }
        return newState
      })
    }
  }

  return (
    <div
      className={`${toggleColorAction ? styles['circle-slice'] : ''} 
      ${className}  
      ${isWrong ? 'border-2 border-red-wrong-choice ' : ''}
      ${isSelected ? 'border-2 border-purple' : ''}`}
      {...rest}
    >
      <svg height={`${RADIUS * 2 + PADDING * 2}px`} width={`${RADIUS * 2 + PADDING * 2}px`}>
        {slices?.map((item) => (
          <SliceCompo
            callback={handleToggleColors}
            id={item.id}
            isWhole={slices.length === 1}
            key={item.id}
            padding={PADDING}
            point1={item.point1}
            point2={item.point2}
            radius={RADIUS}
            sliceColor={item.isColored ? '#7D38D6' : 'white'}
          />
        ))}
      </svg>
    </div>
  )
}
